module.exports = __webpack_public_path__ + "static/media/sort-decreasing.824dd968.svg";